import loadMaps from './loadMaps';
import mapStyles from './mapStyles';

export default () => {
  const node = document.querySelector('[data-control="distributorsMap"]');

  if (! node) {
    return;
  }

  loadMaps(() => {
    distributors(node);
  });
};

const distributors = (node) => {
  const { Map, InfoWindow, Marker, ControlPosition } = google.maps;
  const distributors = JSON.parse(node.dataset.distributors || '[]');

  const infoWindow = new InfoWindow();
  const map = new Map(node, {
    styles: mapStyles,
    zoom: 2,
    minZoom: 1,
    maxZoom: 15,
    mapTypeControl: false,
    streetViewControl: false,
    signInControl: false,
    scrollwheel: true,
    fullscreenControl: false,
    clickableIcons: false,
    center: { lat: 54.902012, lng: -1.554690 },
    zoomControlOptions: { position: ControlPosition.RIGHT_TOP },
  });

  distributors.forEach((distributor, idx) => {

    const marker = new Marker({
      ...markerImage(distributor),
      map: map,
      title: distributor.name,
      zIndex: idx,
      optimized: false,
      position: {
        lat: parseFloat(distributor.location.latitude),
        lng: parseFloat(distributor.location.longitude),
      },
    });

    addMapListener(marker, 'click', () => {

        const phone = distributor.telephone ? `Telephone: <a href="tel:${distributor.telephone}">${distributor.telephone}</a><br>` : '';
        const email_address = distributor.email ? `Email: <a href="mailto:${distributor.email}">${distributor.email}</a><br>` : '';
        const web_url = distributor.web_url ? `Website: <a href="${distributor.web_url}" target="_blank">${distributor.web_url}</a>` : '';

        infoWindow.setContent(`
        <div id="popUp">
          <div id="bodyContent">
            <p class="distributionMap__title">${distributor.title}</p>
            <p class="distributionMap__address">${distributor.address}</p>
            <p class="distributionMap__contact">
            ${phone}
            ${email_address}
            ${web_url}
            </p>
          </div>
        </div>
      `);

      infoWindow.open(map, marker);
    });
  });

  addMapListener(map, 'click', () => {
    infoWindow.close();
  })
};

const markerImage = (distributor) => ({
  icon: {
    url: distributor.type === 'distributor' ? `/themes/app/assets/images/googlemap/map_marker_blue.svg` : `/themes/app/assets/images/googlemap/map_marker_orange.svg`,
    scaledSize: new google.maps.Size(32, 40),
  }
});

const addMapListener = (target, event, callback) =>
  google.maps.event.addListener(target, event, callback);



// WEBPACK FOOTER //
// ./themes/app/assets/js/modules/distributors.js